"use strict";exports.__esModule=true;exports.default=void 0;var _default={"initial.background.background":function initialBackgroundBackground(){return{"rect.appearing":function rectAppearing(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]}}}};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/_internal/components/background/index.animation.js
// module id = nSzA
// module chunks = 5